import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
    const [username, setUsername] = useState("");
    const navigate = useNavigate();
    ///////////////////////////////////////
    const handleLogin = () => {
        if (!username) return;
        localStorage.setItem("token", "fake-token");
        navigate("/dashboard"); //dashboard  الانتقال الى
    };
    //////////////////////////////////////////
    return (
        <div className="min-h-screen flex justify-center items-center bg-gray-100">
            <div className="bg-white p-6 rounded shadow w-80">
                <h2 className="text-xl mb-4 text-center">Login</h2>
                <input
                    className="w-full border p-2 mb-4 rounded"
                    placeholder="Enter your name"
                    onChange={(e)=>setUsername(e.target.value)}
                />
                <button
                    onClick={handleLogin}
                    className="w-full bg-blue-500 text-white p-2 rounded"
                >
                    Login
                </button>
            </div>
        </div>
    );
}
